import { query_attend_group_list } from 'liyu-pc-base/api/org-model';
import { useUserStore } from 'liyu-pc-base/init-plugin';

export default () => {
  const userStore = useUserStore();
  const org = userStore.currentOrg;
  const search_config: any = {
    model: {
      aim_org_id: org?.id,
      is_active: true,
      page_index: 1,
      page_size: 2000,
    },
  };
  return {
    getData: query_attend_group_list,
    searchConfig: search_config,
  };
};
